import React from 'react';
import IconBase from './Icon-base';
export default class Download extends React.Component {
    render() {
        return (
            <IconBase width="26" height="24" viewBox="0 0 26 24" {...this.props}>
                <g id="Canvas" transform="translate(-234 232)">
                    <g id="Group 6">
                        <g id="Action Icon">
                            <use
                                xlinkHref="#path0_fill_dn"
                                transform="matrix(-1 1.22465e-16 -1.22465e-16 -1 254 -214)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Vector 3">
                            <use
                                xlinkHref="#path1_stroke_dn"
                                transform="translate(235 -217)"
                                fill="#4F5056"
                            />
                        </g>
                    </g>
                </g>
                <defs>
                    <path
                        id="path0_fill_dn"
                        fillRule="evenodd"
                        d="M 6.22222 2.8155L 6.22222 18L 7.77778 18L 7.77778 2.8155L 12.8427 7.428L 14 6.375L 7 0L 0 6.375L 1.15733 7.428L 6.22222 2.8155Z"
                    />
                    <path
                        id="path1_stroke_dn"
                        d="M -1 0L -1 7L 1 7L 1 0L -1 0ZM 1 9L 23 9L 23 7L 1 7L 1 9ZM 25 7L 25 0L 23 0L 23 7L 25 7ZM 23 9C 24.1046 9 25 8.10457 25 7L 23 7L 23 7L 23 9ZM -1 7C -1 8.10457 -0.104569 9 1 9L 1 7L 1 7L -1 7Z"
                    />
                </defs>
            </IconBase>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/Download.js